enum CustomerType {
  OWNER = 1,
  COMPANY = 2,
  DRIVER = 3,
}

export default CustomerType;